import React from 'react';
import styles from './FoldersListClipsModal.module.scss';
import Col from '../GridSystem/Col';
import Row from '../GridSystem/Row';
import FoldersItemClips from '../FolderItemClips/FolderItemClips';
import RecordNotFound from '../_empty_state/RecordNotFound';
import EmptyFolders from '../EmptyFolders/EmptyFolders';

const FoldersListClipsModal = ({ folders, isTeam, searchInput, onClick, containerRef }) => {
  return (
    <Col xs={12} className={styles.videoLibrary}>
      <Row className={styles.row}>
        {folders.length
          ? folders
              .filter(({ users }) => (isTeam ? users?.length : !users?.length))
              .map((folder, index) => (
                <FoldersItemClips
                  key={folder.id}
                  folder={folder}
                  folderIndex={index}
                  handleCardClick={onClick}
                  searchInput={searchInput}
                  containerRef={containerRef}
                />
              ))
          : null}
        {folders?.filter(({ users }) => (isTeam ? users?.length : !users?.length))?.length === 0 && (
          <div className={styles.emptyStateContainer}>
            {searchInput && <RecordNotFound searchTerm={searchInput} />}
            {!searchInput && <EmptyFolders type={isTeam ? 'team' : 'folders'} />}
          </div>
        )}
      </Row>
    </Col>
  );
};

export default FoldersListClipsModal;
